﻿(function ($) {
    $.fn.rlVideoCommon = function () {

        $('.videoWrapper .play').hover(function () {
            $(this).addClass('hover');
        });

        $(".videoWrapper .play").mouseout(function () {
            $(this).removeClass('hover');
        });


        $('.videoWrapper .play').on('click touch', function () {
            $(this).addClass('hide');
        });

        ////
        //play button positioning
        ////
        
        function checkVideoHeight() {
           const vidWrapper = document.querySelectorAll('.videoWrapper');
           const playButton = document.querySelectorAll('.videoWrapper .play');

           for (let v = 0; v < vidWrapper.length; v++) {

              let playbuttontop = (vidWrapper[v].offsetHeight - playButton[v].offsetHeight) / 2;
              playbuttontop = playbuttontop.toString() + 'px';
              playButton[v].style.top = playbuttontop;
              playButton[v].classList.remove('transparent');
           }
        }
       setTimeout(checkVideoHeight, 500);
       $(window).on('resize-end', function () {
          checkVideoHeight();
       });

    }
}(jQuery));